<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Date Range</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.salesDateRange"
                            type="daterange"
                            align="left"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            :picker-options="pickerOptions"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">&nbsp;</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-radio-group v-model="searchParams.datatype" size="mini" @input="handleDataTypeChange">
                                <el-radio-button label="Orders"></el-radio-button>
                                <el-radio-button label="Invoices"></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv('searchParams')">Download CSV
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="downloadChart()">Download Chart
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import download from 'downloadjs';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import barChartBase from '../../mixins/bar-chart-base.js';

    export default {
        name: "territorySalesSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                territories: [],
                downloadUrl: '',
                myChart: Object,
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        created() {
            console.log('CREATED')
            const date = new Date();
            date.setDate(date.getDate() - 7)
            console.log('created date')

            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED')
            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams)
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        if (searchTerms.salesDateRange[0] !== null && searchTerms.salesDateRange[0].length !== undefined) {
                            if (searchTerms.salesDateRange[0].toString().includes('/')) {
                                searchTerms.salesDateRange[0] = this.convertDate(searchTerms.salesDateRange[0])
                            }
                        }

                        if (searchTerms.salesDateRange[1] !== null && searchTerms.salesDateRange[1].length !== undefined) {
                            if (searchTerms.salesDateRange[1].toString().includes('/')) {
                                searchTerms.salesDateRange[1] = this.convertDate(searchTerms.salesDateRange[1])
                            }
                        }

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetTerritorySales?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                result = [],
                                custNo = 0,
                                orderDate,
                                orders = response.data.territorySales;

                            this.$parent.sales = orders;

                            if (orders.length > 0) {
                                var colours = [];
                                colours.push('#00103a');
                                colours.push('#00403a');
                                colours.push('#005668');
                                colours.push('#007e94');
                                colours.push('#4f93a8');
                                colours.push('#8db3c3');
                                colours.push('#ccdbe2');

                                var chartId = 'territory-sales-chart',
                                    chartData = barChartBase;
                                chartData['data'].labels = [];
                                chartData['data'].datasets = [];
                                chartData['data'].colours = colours;

                                startDate = new Date(searchTerms.salesDateRange[0]);
                                endDate = new Date(searchTerms.salesDateRange[1]);
                                
                                chartData['data'].datasets.push({});
                                chartData['data'].datasets[0] = {"label":"Toolkit", "data":[], "backgroundColor":[colours[0]], "hoverBackgroundColor":[colours[0]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[1] = {"label":"Directmailr", "data":[], "backgroundColor":[colours[1]], "hoverBackgroundColor":[colours[1]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[2] = {"label":"Email", "data":[], "backgroundColor":[colours[2]], "hoverBackgroundColor":[colours[2]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[3] = {"label":"Bespoke", "data":[], "backgroundColor":[colours[3]], "hoverBackgroundColor":[colours[3]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[4] = {"label":"InstantPrint", "data":[], "backgroundColor":[colours[4]], "hoverBackgroundColor":[colours[4]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[5] = {"label":"PhotoFixr", "data":[], "backgroundColor":[colours[5]], "hoverBackgroundColor":[colours[5]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                                chartData['data'].datasets[6] = {"label":"Delivery", "data":[], "backgroundColor":[colours[6]], "hoverBackgroundColor":[colours[6]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};

                                for (var order, i = 0; order = orders[i++];) {
                                    chartData['data'].labels.push(order.territory);
                                    for (var j = 0; j <= 6; j++) {
                                        switch (j) {
                                        case 0:
                                            chartData['data'].datasets[j].data.push(order.toolkit.toString());
                                            break;
                                        case 1:
                                            chartData['data'].datasets[j].data.push(order.directmailr.toString());
                                            break;
                                        case 2:
                                            chartData['data'].datasets[j].data.push(order.email.toString());
                                            break;
                                        case 3:
                                            chartData['data'].datasets[j].data.push(order.bespoke.toString());
                                            break;
                                        case 4:
                                            chartData['data'].datasets[j].data.push(order.instantprint.toString());
                                            break;
                                        case 5:
                                            chartData['data'].datasets[j].data.push(order.photofixr.toString());
                                            break;
                                        case 6:
                                            chartData['data'].datasets[j].data.push(order.delivery.toString());
                                        }
                                        chartData['data'].datasets[j].backgroundColor.push([colours[j]]);
                                        chartData['data'].datasets[j].hoverBackgroundColor.push([colours[j]]);
                                        chartData['data'].datasets[j].borderColor.push(["#a0b2cc"]);
                                        chartData['data'].datasets[j].hoverBorderColor.push(["#1853a5"]);
                                        chartData['data'].datasets[j].borderWidth.push([1]);
                                    }
                                }

                                chartData['options'].animation = { onComplete: this.chartCompleted };

                                Chart.plugins.register({
                                    beforeDraw: function(chartInstance) {
                                        var ctx = chartInstance.chart.ctx;
                                        ctx.fillStyle = "white";
                                        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
                                    }
                                });

                                var ctx = document.getElementById(chartId);
                                this.myChart = new Chart(ctx, {
                                    type: chartData.type,
                                    data: chartData.data,
                                    options: chartData.options,
                                })
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            handleDataTypeChange(val) {
                console.log('handleDataTypeChange');
                console.log(val);
                this.searchParams.datatype = val;
                this.getSales('searchParams');
            },
            chartCompleted() {
                console.log("chartCompleted");
                this.downloadUrl = this.myChart.toBase64Image();
                console.log("this.downloadUrl=" + this.downloadUrl);
            },
            downloadChart() {
                download(this.downloadUrl);
            },
            csv(searchParams) {
                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        if (searchTerms.salesDateRange[0] !== null && searchTerms.salesDateRange[0].length !== undefined) {
                            searchTerms.salesDateRange[0] = this.convertDate(searchTerms.salesDateRange[0])
                        }

                        if (searchTerms.salesDateRange[1] !== null && searchTerms.salesDateRange[1].length !== undefined) {
                            searchTerms.salesDateRange[1] = this.convertDate(searchTerms.salesDateRange[1])
                        }

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetTerritorySalesCsv?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var orders = response.data.territorySalesCsv,
                                monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                            const fields = [
                                {label: 'Order Id', value: 'order_Id'},
                                {label: 'Ordered', value: (row, field) => row.ordered.replace('T', ' ').replace(/\.[0-9]{3}/, '').replace(/\.[0-9]{2}/, '').replace(/\.[0-9]{1}/, '')},
                                {label: 'Ordered Month', value: (row, field) => this.returnMonthFromDate(row.ordered)},
                                {label: 'Source Id', value: 'source_Id'},
                                {label: 'Job Id', value: 'job_Id'},
                                {label: 'Category', value: 'category'},
                                {label: 'Brand', value: 'brand'},
                                {label: 'Price Code', value: 'price_Code'},
                                {label: 'Product', value: 'product'},
                                {label: 'Stock', value: 'stock'},
                                {label: 'Finishing', value: 'finishing'},
                                {label: 'Product Category', value: 'product_Category'},
                                {label: 'Product Description', value: 'product_Description'},
                                {label: 'Territory', value: 'territory'},
                                {label: 'Status', value: 'status'},
                                {label: 'Branch', value: 'branch'},
                                {label: 'Name', value: 'name'},
                                {label: 'Job Name', value: 'job_Name'},
                                {label: 'Quantity', value: 'quantity'},
                                {label: 'Value', value: 'value'},
                                {label: 'Billing Status', value: 'billing_Status'},
                                {label: 'Cost Price', value: 'cost_Price'},
                                {label: 'Margin (%)', value: (row, field) => row.marginpercent + '%'}
                            ];

                            this.downloadCsv(this.exportDate, fields, orders)

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>